import React from 'react'
import { Icon } from '@ant-design/compatible'
import styles from './LegacyIcon.module.scss'

const LegacyIcon = ({ icon, color }) => (
  <Icon type={icon} className={styles[color]} style={{ color: color }} />
)

export default LegacyIcon
